import { useQuery } from '@tanstack/react-query';

import { permissionsApi } from '@/api/services/permissions.api';
import { rolesApi } from '@/api/services/roles.api';
import { USERS_ROLES_QUERY_KEYS } from '../constants';

export function usePermissionsCatalog() {
    return useQuery({
        queryKey: USERS_ROLES_QUERY_KEYS.PERMISSIONS,
        queryFn: () => permissionsApi.list(),
        staleTime: 60 * 60 * 1000, // catalog rarely changes; cache for 1 hour
    });
}

export function useMyPermissions() {
    return useQuery({
        queryKey: USERS_ROLES_QUERY_KEYS.MY_PERMISSIONS,
        queryFn: () => rolesApi.getMyPermissions(),
        staleTime: 5 * 60 * 1000,
    });
}
